module.exports = __webpack_public_path__ + "static/media/Lexham Gardens Kitchen (9).a6d7eab9.jpg";